module.exports = __webpack_public_path__ + "img/playBtnv1.f871522b.png";